module.exports = __webpack_public_path__ + "img/affin-bank-img.ff9b74a5.png";